import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useCSS } from '../../lib/hooks';

import ActionButton from './ActionButton';

import FacebookLogo from '../svg/FacebookLogo';
import GoogleLogo from '../svg/GoogleLogo';
import LinkedInLogo from '../svg/LinkedInLogo';
import TwitchLogo from '../svg/TwitchLogo';
import RealMadridLogo from '../svg/RealMadridLogo';
import Tooltip from './Tooltip';
import TiktokLogo from '../svg/TiktokLogo';
import MailLogo from '../svg/MailLogo';
import PhoneLogo from '../svg/PhoneLogo';
import UserLogo from '../svg/UserLogo';

const arrayEquals = (a, b) => {
	return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
};

const SocialLoginButton = (props) => {
	useCSS('comp/login_buttons.css');

	const [ networks, setNetworks ] = useState(props?.networks ?? ['facebook', 'google']);

	useEffect(() => {
		if(!arrayEquals(props.networks, networks)) {
			setNetworks(props.networks);
		}
	}, [ props.networks ]);

	if(networks.length == 0) return null;

	const login = (net) => {
		if(props.login != undefined && (net.prevent_login == undefined || !net.prevent_login)) {
			props.login(net.network);
			return;
		}

		switch(net.network) {
			case 'facebook':
				fbEnsureInit(() => {
					FB.login((res) => {
						if(net.cb != undefined) net.cb(res);
					}, { scope:net.scope }); //,auth_type: 'rerequest'
				});
				break;

			case 'google':
			case 'linkedin':
			case 'twitch':
			case 'tiktok':
			case 'madrid':
				let popup = window.open('', '_blank', "width=500,height=400,scrollbars=no");
				$.get(`/utils/social/${net.network}`, (resp) => {
					if(resp.status == 0) {
						popup.location.href = resp.url;
						$(window).on('focus', (event) => {
							$.get(`/utils/social/${net.network}`, (resp2) => {
								if(net.cb != undefined) net.cb({customResponse:resp2});
							}, 'JSON');
							$(window).off('focus');
						});
					} else {
						popup.close();
						if(net.cb != undefined) net.cb({customResponse:resp});
					}
				}, 'JSON');
				break;

			case 'email':
			case 'code':
			case 'sms':
				if(net.cb != undefined) net.cb({});
				break;
		}
	};

	return (
		<div class="gui_social_login_ctas" style={props.styles}>
			{networks.map((net, n) => {
				if(net.hide_button != undefined && net.hide_button) return null;

				let button_props = net?.props ?? {};

				const disabled = net?.disabled ?? false;

				let new_props = Object.assign({}, button_props);
				let new_class = Object.assign({}, new_props._class);
				if(new_class.other == undefined) new_class.other = '';
				new_class.other += ' netButton';
				new_class.other += ' gui_is_not_animated';

				if(new_props._class != undefined) delete new_props._class;

				let label = net?.label ?? false;
				let svg_icon = null;
				switch(net.network) {
					case 'facebook':
						svg_icon = <span class="network_login_icon f_logo_container"><FacebookLogo /></span>;
						if(label === false) label = "***Login with Facebook";
						break;

					case 'google':
						svg_icon = <span class="network_login_icon g_logo_container"><GoogleLogo /></span>;
						if(label === false) label = "Login with Google";
						break;

					case 'linkedin':
						svg_icon = <span class="network_login_icon l_logo_container"><LinkedInLogo /></span>;
						if(label === false) label = "Login with Linkedin";
						break;

					case 'twitch':
						svg_icon = <span class="network_login_icon t_logo_container"><TwitchLogo /></span>;
						if(label === false) label = "Login with Twitch";
						break;
						
					case 'tiktok':
						svg_icon = <span class="network_login_icon tt_logo_container"><TiktokLogo /></span>;
						if(label === false) label = "Login with Twitch";
						break;

					case 'madrid':
						svg_icon = <span class="network_login_icon m_logo_container"><RealMadridLogo /></span>;
						if(label === false) label = "Login with Real Madrid";
						break;

					case 'email':
						svg_icon = <span class="network_login_icon ml_logo_container"><MailLogo /></span>;
						if(label === false) label = "Login with E-mail";
						break;

					case 'code':
						svg_icon = <span class="network_login_icon u_logo_container"><UserLogo /></span>;
						if(label === false) label = "Login with username";
						break;

					case 'sms':
						svg_icon = <span class="network_login_icon ph_logo_container"><PhoneLogo /></span>;
						if(label === false) label = "Login with SMS";
						break;

					default:
						return null;
				}

				return (
					<div key={n} class={`is_${net.network}_login gui_pos_rel`}>
						<ActionButton
							{...new_props}
							svg_icon={svg_icon}
							_class={new_class}
							onClick={(!disabled) ? () => login(net) : null}
							disabled={disabled}
						>{label}</ActionButton>

						{(disabled && (window?.platform ?? 'desktop') == 'desktop') && (
							<Tooltip
								position='top'
								with_icon={false}
							>Social Login disabled for security</Tooltip>
						)}
					</div>
				)
			})}
		</div>
	);
}

export default injectIntl(SocialLoginButton);